import React, { useEffect } from "react";
import { Link, useHistory, useLocation } from 'react-router-dom';
import { CSVLink } from "react-csv";
import { NepaliDatePicker } from "nepali-datepicker-reactjs";
import "nepali-datepicker-reactjs/dist/index.css";
import ReactToPrint, { useReactToPrint } from 'react-to-print';
import { AdsGETApiAuth, AdsPUTApi } from "../../Constant/api";
import { slugs } from "../../Constant/slugs";

const { adToBs, bsToAd, calculateAge } = require('@sbmdkl/nepali-date-converter');

export default function Topics() {
  const [TopicsList, setTopicsList] = React.useState([])
  const [TopicsList1, setTopicsList1] = React.useState([])
  const [SubjectList, setSubjectList] = React.useState([])
  const [AllTopicList, setAllTopicList] = React.useState([])
  const [firstSelection, setFirstSelection] = React.useState("");
  const [secondSelection, setSecondSelection] = React.useState("");
  const [choose, setChoose] = React.useState(0);
  const ID = "471"
  useEffect(() => {
    getAllData()
  }, [])
  const getAllData = () => {
    AdsGETApiAuth({}, `${slugs.db_slug_topics}/${ID}`)
      .then((res) => {
        var getTopics = Object.values(JSON.parse(res.data.meta.topics_details))
        setTopicsList1(getTopics)
        setTopicsList(getTopics)
      })
  }
  const getUnique = (data, key) => {
    const uniqueData = [
      ...new Map(data.map((item) => [item[key], item])).values(),
    ];
    return uniqueData
  }
  return (
    <div>
      <div>
        <span onClick={() => {
          setChoose(0)
        }}>{firstSelection}</span> / {secondSelection}</div>
      {choose == 0 &&
        <div className="topic-grid">
          {getUnique(TopicsList, "subject").map((item, index) => (
            <div className="topic-card" key={index}
              onClick={() => {
                setFirstSelection(item.subject)
                setSubjectList(TopicsList1.filter(a => a.subject == item.subject))
                setChoose(1)
              }}
            >
              <div style={{ height: "auto", padding: "10px", fontSize: "16px", margin: "5px", backgroundColor: "#fff" }}>
                {item.subject}
              </div>
            </div>
          ))}
        </div>
      }
      {choose == 1 &&
        <div className="topic-grid">
          {getUnique(SubjectList, "Title").map((item, index) => (
            <div className="topic-card" key={index}
              onClick={() => {
                setSecondSelection(item.Title)
                setAllTopicList(SubjectList.filter(a => a.Title == item.Title))
                setChoose(2)

              }}
            >
              <div style={{ padding: "10px", fontSize: "16px", margin: "5px", backgroundColor: "#fff" }}>
                Subject: {firstSelection}<br />
                Title: {item.Title}
              </div>
            </div>
          ))}
        </div>
      }
      {choose == 2 &&
        <div className="topic-grid">
          {getUnique(SubjectList, "Title").map((item, index) => (
            <div className="topic-card" key={index}
              onClick={() => {
                // setSecondSelection(item.Title)
              }}
            >
              <div style={{ padding: "10px", fontSize: "16px", margin: "5px", backgroundColor: item.Teacher == "" ? "#fff" : "#ffc8c8" }}>
                <span style={{ fontSize: "20px", fontWeight: "bold" }}>Subject:</span> <span style={{ fontSize: "16px", fontWeight: "bold" }}>{firstSelection}</span><br />
                <span style={{ fontSize: "20px", fontWeight: "bold" }}>Title:</span> <span style={{ fontSize: "16px", fontWeight: "bold" }}>{item.Title}</span><br />
                <span style={{ fontSize: "20px", fontWeight: "bold" }}>Topic:</span> <span style={{ fontSize: "16px", fontWeight: "bold" }}>{item.Topic}</span><br />
                {item.Teacher !== "" &&
                  <>
                    <span style={{ fontSize: "20px", fontWeight: "bold" }}>Teacher:</span> <span style={{ fontSize: "16px", fontWeight: "bold" }}>{item.Teacher}</span><br />
                    <span style={{ fontSize: "20px", fontWeight: "bold" }}>Date:</span> <span style={{ fontSize: "16px", fontWeight: "bold" }}>{item.Date}</span><br />
                    <div onClick={() => {
                      const j = TopicsList1.findIndex(obj => obj["ID"] === item.ID);
                      TopicsList1[j] = {
                        ...TopicsList1[j],
                        "Teacher": "",
                        "Date": ""
                      }
                      AdsPUTApi({
                        meta: {
                          topics_details: JSON.stringify(TopicsList1)
                        }
                      }, slugs.db_slug_topics, "471")
                        .then(res => {
                          getAllData()
                          setChoose(0)

                        })
                    }}>Clear Teacher</div>
                  </>
                }
              </div>
            </div>
          ))}
        </div>
      }
    </div>
  )

}